/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection06FoiChanged, m11ReportSection06ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection06Foi, selectM11ReportSection06Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveTrialInterventionChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section06State, setAlertModalState, setStartingSection06State) => {

    let changesStates = {
        section06State: section06State
    };
    let response = await saveM11Changes(apiToken, 23, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection06Resource) {
            dispatch(m11ReportSection06ResourceChanged(response.m11ReportSection06Resource));
        }
        setStartingSection06State(JSON.parse(JSON.stringify(section06State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step023TrialInterventionPart3 = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection06Foi = useSelector(selectM11ReportSection06Foi);
    const m11ReportSection06Resource = useSelector(selectM11ReportSection06Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section06State, setSection06State] = useState({
        "section661Status": "empty", "section661Xhtml": "",
        "section662Status": "empty", "section662Xhtml": "",
        "section663Status": "empty", "section663Xhtml": ""
    });
    const [startingSection06State, setStartingSection06State] = useState({
        "section661Status": "empty", "section661Xhtml": "",
        "section662Status": "empty", "section662Xhtml": "",
        "section663Status": "empty", "section663Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section06State, startingSection06State)),
        async saveAllChanges() {
            await saveTrialInterventionChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section06State, setAlertModalState, setStartingSection06State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section661Status": "empty", "section661Xhtml": "",
                "section662Status": "empty", "section662Xhtml": "",
                "section663Status": "empty", "section663Xhtml": "",
                "loaded": true
            };
            setSection06State(startingData);
            setStartingSection06State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[6]?.entry?.length) {
                let m11ReportSection006Foi = getIdFromReference(m11ReportContainerResource.section[6].entry[0]);
                if (m11ReportSection006Foi && !isNaN(m11ReportSection006Foi) && m11ReportSection006Foi !== m11ReportSection06Foi) {
                    dispatch(m11ReportSection06FoiChanged(m11ReportSection006Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection06Foi && !isNaN(m11ReportSection06Foi)) {
            loadResource(m11ReportSection06Foi, "M11ReportSection06", apiToken, dispatch);
        }
    }, [m11ReportSection06Foi]);

    useEffect(() => {
        if (m11ReportSection06Resource && Object.keys(m11ReportSection06Resource).length > 0) {
            let startingData = {
                "section661Status": "empty", "section661Xhtml": "",
                "section662Status": "empty", "section662Xhtml": "",
                "section663Status": "empty", "section663Xhtml": "",
                "loaded": true
            };
            if (m11ReportSection06Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection06Resource.section[0].section[5]?.section?.length > 0) {
                    if (m11ReportSection06Resource.section[0].section[5].section[0]?.text?.div &&
                        m11ReportSection06Resource.section[0].section[5].section[0].text.status !== "empty") {
                        startingData.section661Status = m11ReportSection06Resource.section[0].section[5].section[0].text.status;
                        startingData.section661Xhtml = m11ReportSection06Resource.section[0].section[5].section[0].text.div;
                    }
                    if (m11ReportSection06Resource.section[0].section[5].section?.[1]?.text?.div &&
                        m11ReportSection06Resource.section[0].section[5].section[1].text.status !== "empty") {
                        startingData.section662Status = m11ReportSection06Resource.section[0].section[5].section[1].text.status;
                        startingData.section662Xhtml = m11ReportSection06Resource.section[0].section[5].section[1].text.div;
                    }
                    if (m11ReportSection06Resource.section[0].section[5].section?.[2]?.text?.div &&
                        m11ReportSection06Resource.section[0].section[5].section[2].text.status !== "empty") {
                        startingData.section663Status = m11ReportSection06Resource.section[0].section[5].section[2].text.status;
                        startingData.section663Xhtml = m11ReportSection06Resource.section[0].section[5].section[2].text.div;
                    }
                }
                setSection06State(startingData);
                setStartingSection06State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection06Resource]);

    return <div>
        <h3>Complete Section 6.6 Preparation, Storage, Handling and Accountability of Investigational Trial Intervention</h3>
        {!(m11ReportSection06Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 23 (Complete Section 6.6 Preparation, Storage, Handling and Accountability of Investigational Trial Intervention) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>
                {section06State.loaded && <>
                    <h4 style={{ marginBottom: "0px" }}>Enter data for Section 6.6.1 Preparation of Investigational Trial Intervention.</h4>
                    <TextDivEntry elementName="section661Xhtml"
                        startingValue={section06State.section661Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>Enter data for Section 6.6.2 Storage and Handling of Investigational Trial Intervention.</h4>
                    <TextDivEntry elementName="section662Xhtml"
                        startingValue={section06State.section662Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>Enter data for Section 6.6.3 Accountability of Investigational Trial Intervention.</h4>
                    <TextDivEntry elementName="section663Xhtml"
                        startingValue={section06State.section663Xhtml}
                        setResourceState={setSection06State} />
                </>}
            </>
        }
    </div >
});

const M11Step023TrialInterventionPart3HelperText = <div>
    <h3>Complete Section 6.6 Preparation, Storage, Handling and Accountability of Investigational Trial Intervention</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 6.6.1 Preparation of Investigational Trial Intervention.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe any preparation of the investigational trial intervention, and when necessary, who should prepare it. When applicable, describe the maximum hold time once thawed/mixed before administration. Include thawing, diluting, mixing, and reconstitution/preparation instructions. For drug/device combination products, include any relevant assembly or use instructions and reference the package insert that is provided separately.</p>
            <p>If the instructions are lengthy or complicated, it is acceptable to reference the package insert (if applicable) or include instructions in separate documents provided to the site (e.g., a pharmacy manual) and reference the separate documents.</p>
        </div>
        <p>Enter data for Section 6.6.2 Storage and Handling of Investigational Trial Intervention.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe storage and handling requirements (e.g., protection from light, temperature, humidity) for the investigational trial intervention(s). For trials in which multidose vials are utilised, provide additional information regarding stability and expiration time after initial use (e.g., if the seal is broken).</p>
            <p>Explain how the investigational trial intervention will be provided to the investigator. If applicable, include details about kits, packaging, or other material of the investigational trial intervention for blinding purposes.</p>
            <p>If the instructions are lengthy or complicated, it is acceptable to reference the package insert (if applicable) or include instructions in separate documents provided to the site (e.g., a pharmacy manual) and reference the separate documents.</p>
        </div>
        <p>Enter data for Section 6.6.3 Accountability of Investigational Trial Intervention.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the accountability method, including:</p>
            <p>how the investigational trial intervention will be distributed</p>
            <p>who will distribute the investigational trial intervention</p>
            <p>participation of a drug storage repository or pharmacy, if applicable</p>
            <p>plans for disposal or return of unused product</p>
            <p>plans for reconciliation of investigational trial intervention, if applicable</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step023TrialInterventionPart3ValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 23, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 23 (Complete Section 6.6 Preparation, Storage, Handling and Accountability of Investigational Trial Intervention) {validationCheckState.step23numberOfChecks} issues checked. {validationCheckState.step23numberPassed} passed. {validationCheckState.step23numberFailed} failed.</h4>
        <p>Section 6.6 heading is 'Preparation, Storage, Handling and Accountability of Investigational Trial Intervention': {validationCheckState.resultCheckSection66Heading}</p>
        <p>Section 6.6 Preparation, Storage, Handling and Accountability of Investigational Trial Intervention does not have text: {validationCheckState.resultChecksection66Text}</p>
        <p>Section 6.6.1 heading is 'Preparation of Investigational Trial Intervention': {validationCheckState.resultCheckSection661Heading}</p>
        <p>Section 6.6.1 Preparation of Investigational Trial Intervention has content: {validationCheckState.resultCheckSection661Content}</p>
        <p>Section 6.6.2 heading is 'Storage and Handling of Investigational Trial Intervention': {validationCheckState.resultCheckSection662Heading}</p>
        <p>Section 6.6.2 Storage and Handling of Investigational Trial Intervention has content: {validationCheckState.resultCheckSection662Content}</p>
        <p>Section 6.6.3 heading is 'Accountability of Investigational Trial Intervention': {validationCheckState.resultCheckSection663Heading}</p>
        <p>Section 6.6.3 Accountability of Investigational Trial Intervention has content: {validationCheckState.resultCheckSection663Content}</p>
    </div>}  </div>

}

export default M11Step023TrialInterventionPart3;
export { M11Step023TrialInterventionPart3HelperText, M11Step023TrialInterventionPart3ValidationCheck };